import React, { memo } from 'react';
import ForcePasswordReset from "../Message/ForcePasswordReset/ForcePasswordReset";
import NoCheggAccount from "./NoCheggAccount/NoCheggAccount";
import { LoginErrorsEnum } from "../../lib/constants";
import { Container, ErrorBanner, SuccessBanner } from "./Message.styles";
import { NotificationTypes } from '@chegg-ui/notification-banner';
var Message = function Message(props) {
  var text = props.text,
    type = props.type,
    noMargin = props.noMargin;
  var renderMessage = function renderMessage() {
    switch (text) {
      case LoginErrorsEnum.LOCKED_SUSPICIOUS_ACTIVITY:
        return /*#__PURE__*/React.createElement(ForcePasswordReset, null);
      case LoginErrorsEnum.NO_CHEGG_ACCOUNT:
        return /*#__PURE__*/React.createElement(NoCheggAccount, null);
      default:
        if (type === NotificationTypes.Success) {
          return /*#__PURE__*/React.createElement(SuccessBanner, {
            title: '',
            type: type,
            message: text,
            id: "success_message",
            bannerStyle: 'inline'
          });
        }
        return /*#__PURE__*/React.createElement(ErrorBanner, {
          title: '',
          type: NotificationTypes.Error,
          message: text,
          id: "error_message",
          bannerStyle: 'inline'
        });
    }
  };
  return /*#__PURE__*/React.createElement(Container, {
    "data-test": "message",
    noMargin: noMargin
  }, renderMessage());
};
export default /*#__PURE__*/memo(Message);